import { Component, OnInit } from '@angular/core';
// import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'app-zonals',
  templateUrl: './zonals.component.html',
  styleUrls: ['./zonals.component.css']
})
export class ZonalsComponent implements OnInit {

  responsiveOptions: any;
  products: any;
  ngOnInit(): void {

    this.products = [
      {
        name: 'Slide1',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      },
      {
        name: 'Slide2',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      },
      {
        name: 'Slide3',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      },
      {
        name: 'Slide3',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      },
      {
        name: 'Slide3',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      },
      {
        name: 'Slide3',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      },
      {
        name: 'Slide3',
        image: '../../../assets/images/users/1.jpg',
        price: 120
      }
    ]

    this.responsiveOptions = [
      {
          breakpoint: '1199px',
          numVisible: 3,
          numScroll: 1
      },
      {
          breakpoint: '991px',
          numVisible: 2,
          numScroll: 1
      },
      {
          breakpoint: '767px',
          numVisible: 1,
          numScroll: 1
      }
  ];
}

}
